import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const DataBlurbPrintSummary = ({
  rank,
  themeName,
  prevalence,
  n,
}): JSX.Element => {
  return (
    <View
      style={{
        backgroundColor: 'black',
        borderRadius: 6,
        height: 120,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: 12,
      }}
    >
      <Text style={{
        fontFamily: 'Helvetica-Bold',
      }}>#{rank}: {themeName}</Text>
      <View>
        <Text style={{
          fontFamily: 'Courier',
        }}>Prevalence</Text>
        <Text style={{
          fontFamily: 'Helvetica-Bold',
          fontSize: 39,
          lineHeight: 1,
        }}>{prevalence}</Text>
      </View>
      <Text>{n} block group{n === 1 ? '' : 's'}</Text>
    </View>
  );
};

export default DataBlurbPrintSummary;
